import { type Ref, ref, watch } from 'vue'

export function useDebouncedValue<T>(value: Ref<T>, timeoutMs = 500) {
  const debouncedValue = ref(value.value)

  let timeoutId: number | null = null

  watch(value, value => {
    if (timeoutId !== null) clearTimeout(timeoutId)

    timeoutId = setTimeout(() => {
      debouncedValue.value = value
    }, timeoutMs)
  })

  return debouncedValue
}
